<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      @if (WorkflowActions?.Transitions?.length > 0) {
        <span class="buttons is-right ml-2" style="display:inline-flex; flex-wrap: wrap; justify-content: flex-end; gap: .5rem;">
          @for (t of WorkflowActions.Transitions; track t) {
            <button type="button" class="button"
              [ngClass]="{ 'is-danger': (t.Name || '').toLowerCase() === 'decline', 'is-primary': (t.Name || '').toLowerCase() !== 'decline' }"
              (click)="ExecutePermitTransition(t.Id)">
              <span class="icon-text">
                @if (t.Name === 'Approve') {
                  <span class="icon">
                    <i class="fa fa-check"></i>
                  </span>
                }
                <span>{{t.Name}}</span>
              </span>
            </button>
          }
        </span>
      }
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading" style="display:flex; align-items:center; justify-content:space-between;">
            <span>Hotel Guest Details</span>
            <span class="tags">
              <span class="tag is-light hotelreservation-status-tag">{{Model.CurrentStateName}}</span>
            </span>
          </p>
          <div class="panel-block">
            <span class="label">Guest ID</span>
            <span class="value">#{{Model.Id}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Group</span>
            <span class="value">{{Model.ParkingPermitTypeName}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Name</span>
            <span class="value">{{(Model.GuestFirstName || '') + ' ' + (Model.GuestLastName || '')}}</span>
          </div>
          @if (Model.GuestRoomNumber) {
            <div class="panel-block">
              <span class="label">Room Number</span>
              <span class="value">{{Model.GuestRoomNumber}}</span>
            </div>
          }
          @if (Model.GuestPlateNumber) {
            <div class="panel-block">
              <span class="label">Plate Number</span>
              <span class="value">{{Model.GuestPlateNumber}}</span>
            </div>
          }
          <div class="panel-block">
            <span class="label">Active Dates</span>
            <span class="value">
              <app-daterangedisplay FieldName="Active Dates" [StartDate]="Model.StartDateLocalFriendlyString" [EndDate]="Model.EndDateLocalFriendlyString"></app-daterangedisplay>
            </span>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading" style="display:flex; align-items:center; justify-content:space-between;">
            <span>Payment Information</span>
          </p>
          <div class="panel-block">
            <span class="label">Price</span>
            <span class="value">{{Model.TotalStayPrice | currency}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Payment Status</span>
            <span class="value">
              @if (Model.IsPaid) {
                <span class="tag is-success is-light">Paid</span>
              } @else {
                <span class="tag is-warning is-light">Unpaid</span>
              }
            </span>
          </div>
          @if (Model.LastPaidOnLocalFriendlyString) {
            <div class="panel-block">
              <span class="label">Payment Date</span>
              <span class="value">{{ Model.LastPaidOnLocalFriendlyString }}</span>
            </div>
          }
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Vehicles
          </p>
          @if (Model.Vehicles == null || Model.Vehicles.length == 0) {
            <div class="panel-block">
              <span class="value">No vehicles assigned.</span>
            </div>
          }
          @if (Model.Vehicles != null && Model.Vehicles.length > 0) {
            <div class="panel-block" style="width:100%">
              <table class="table is-fullwidth is-striped">
                <thead>
                  <tr>
                    <th>Plate</th>
                    <th>Color</th>
                    <th>Brand</th>
                    <th>Model</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of Model.Vehicles; track v) {
                    <tr>
                      <td>{{v.PlateNumber}}</td>
                      <td>{{v.Color}}</td>
                      <td>{{v.Brand}}</td>
                      <td>{{v.Model}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </article>
      </div>
    </div>
  </div>
}
